import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import useAdminAccess from "hooks/useAdminAccess";
import { Link, Navigate, useParams } from "react-router-dom";
import { requiredAdminPermissionsForPath } from "services/adminAccess";
import Records from "./Records";
import ProgrammeSettings from "./ProgrammeSettings";
import ReviewQueue from "./ReviewQueue";
import Reports from "./Reports";
import Participant from "./Participant";
const sections = [
  ["records", "Records"],
  ["review", "Review queue"],
  ["programme", "Programme settings"],
  ["reports", "Reports"],
];
export default function ReferralAdmin() {
  const { section, userId } = useParams();
  const { canAny, accessReady } = useAdminAccess();
  const visible = sections.filter(([key]) =>
    canAny(requiredAdminPermissionsForPath(`/referrals/${key}`) ?? []),
  );
  if (!accessReady) return <p role="status">Loading admin access…</p>;
  if (!section && !userId && visible.length)
    return <Navigate replace to={`/referrals/${visible[0][0]}`} />;
  const selected = userId ? "records" : section;
  const allowed = visible.some(([key]) => key === selected);
  return (
    <Container className="flex-col md:flex-row">
      <AdminSidebar />
      <Main className="min-w-0 pb-12 text-left">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-medium">Refer & Earn</h1>
          <p className="mt-2 text-sm text-gray-500">
            Manage referral rules, review holds and rewards across your
            permitted markets.
          </p>
          <nav
            aria-label="Referral sections"
            className="flex gap-2 mt-6 mb-6 overflow-x-auto border-b border-gray-200"
          >
            {visible.map(([key, label]) => (
              <Link
                key={key}
                aria-current={key === selected ? "page" : undefined}
                className={`shrink-0 px-4 py-3 text-sm ${key === selected ? "border-b-2 border-black font-semibold" : "text-gray-500"}`}
                to={`/referrals/${key}`}
              >
                {label}
              </Link>
            ))}
          </nav>
          {!allowed ? (
            <p role="alert">You do not have access to this referral section.</p>
          ) : userId ? (
            <Participant key={userId} userId={Number(userId)} />
          ) : section === "records" ? (
            <Records />
          ) : section === "review" ? (
            <ReviewQueue />
          ) : section === "programme" ? (
            <ProgrammeSettings />
          ) : (
            <Reports />
          )}
        </div>
      </Main>
    </Container>
  );
}
